import { render, staticRenderFns } from "./HomeNewGoogle.vue?vue&type=template&id=42058d17&"
import script from "./HomeNewGoogle.vue?vue&type=script&lang=js&"
export * from "./HomeNewGoogle.vue?vue&type=script&lang=js&"
import style0 from "./HomeNewGoogle.vue?vue&type=style&index=0&id=42058d17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports